import {
    Button, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle
} from '@mui/material';
import './popup.css';
import api from '../../../service/api';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelIcon from '@mui/icons-material/Cancel'
import { useHistory } from "react-router-dom";

const PopupMerge = (props) => {
    const history = useHistory();
    const [value, setValue] = useState('');
    const [submit, setSubmit] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [popUptext, setPopUptext]= useState({comment : '' , success : false})
        

   const onOkClick = () =>{
       history.push('/track-request')
       
   }

   
    const mergeRequest = () => {
        
        setErrorFlag(true);
        if (value && value.length > 0) {
        let request = JSON.parse(JSON.stringify(props.detail))
        
        request['status'] = 'Pending';
        request['requesttype'] = "Merge"
        request['comment'] = value
        api.postMergeRequest({...request}).then(res => { 
            setPopUptext({comment: "Your request is being processed. You will receive an email notification on successful submission or in case of any failures." , success: true }) 
            setSubmit(true);
        })
        .catch((error)=>{
            setPopUptext({comment: 'Unable to fullfill your request due to some technical issue. Please try again later.', success: false }) 
            setSubmit(true);
            
        })
        }

    }
    const handelChange = (event) => {
        
        setValue(event.target.value)
    }
    return (
        <Dialog
            open={props.open}
            onClose={props.onCancel}
            
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="lilly-popup" color='primary' className='fw-bold'>{props.title || ''}</DialogTitle>
            <DialogContent>
            {submit ? popUptext.success ? <center><CheckCircleRoundedIcon className='success' /></center> : <center><CancelIcon className='secondary' /></center> :
                    <DialogContentText id="lilly-popup-des">
                        {props.message}
                    </DialogContentText>
             }

            
                
                {
                    submit &&
                    <>
                        <h6 id="mergePopupMsg">
                            {popUptext.comment}
                            
                        </h6>
                    </>
                }
                 {
                    props.success && !submit &&
                    <TextField
                        value={value}
                        className='w-100'
                        onChange={handelChange}
                        multiline
                        rows={5}
                        variant="outlined"
                        error={errorFlag && value.length === 0}
                        helperText={errorFlag && value.length === 0 ? "Please Enter Value" : " "}
                    />
                }
                
            </DialogContent>
            <DialogActions sx={{mr: '15px'}}>
                {
                    props.success && !submit &&
                    <Button 
                    onClick={mergeRequest} 
                    color="error" variant="contained" autoFocus className='_wg-dynamic-text'>
                        Submit
                                </Button>
                }
                { (props.success && !popUptext.success ) && <Button onClick={props.onCancel} color="error" variant="outlined" autoFocus className='_wg-dynamic-text'>
                    Close
                                </Button>}

                { (submit && popUptext.success ) && <Button onClick={()=>onOkClick()} color="error" variant="contained" autoFocus className='_wg-dynamic-text'>
                    Confirm
                                </Button>}
            </DialogActions>

        </Dialog>
    )
}

export default PopupMerge;